import React from 'react';
import { LinkedDestinationEntitlement, Maybe } from '@css-xp/graphtypes/src/generated-types-new';
import { EntitlementIcon, SummarySectionV2 } from '@css-xp/base';
import { getEntitlementRouteCCPV2 } from '@atlassian/cssxp-utils-entitlement';
import { Link } from 'react-router-dom';

interface props {
  isApp: boolean | null | undefined;
  totalBilledUsers: Maybe<number> | undefined;
  linkedEntitlements: LinkedDestinationEntitlement[];
  isProductRedirectEnabled?: boolean;
}

export const LastBilledUsersSection = ({
  isApp,
  totalBilledUsers = 0,
  linkedEntitlements,
  isProductRedirectEnabled = true,
}: props) => {
  if (isApp && linkedEntitlements.length > 0) {
    const sortedParentEntitlements = linkedEntitlements.sort(
      (a, b) => (Number(b?.billedUsers) ?? 0) - (Number(a?.billedUsers) ?? 0)
    );
    const { productId, entitlementNumber, cloudSiteId, productName, billedUsers = 0 } = sortedParentEntitlements[0];
    return (
      <SummarySectionV2.SummaryGridCalloutItem testId="summary-total-billed-users">
        <div className="billed-users">
          <label>Last billed users</label>
          <div className="entitlement-details-column">
            {Number(totalBilledUsers) > Number(billedUsers) ? totalBilledUsers : billedUsers}
          </div>
          {isProductRedirectEnabled ? (
            <Link
              to={getEntitlementRouteCCPV2(productId, entitlementNumber as string, cloudSiteId)}
              onClick={(e) => e.stopPropagation()}
              data-testid="product-link"
              className="avatar-container"
            >
              {!!productId && <EntitlementIcon productId={productId} isCloud={true} className="avatar medium" />}{' '}
              <span data-testid={productId}>{productName ?? 'Unnamed product'}</span>
            </Link>
          ) : (
            <div data-testid="product-link" className="avatar-container">
              {!!productId && <EntitlementIcon productId={productId} isCloud={true} className="avatar medium" />}{' '}
              <span data-testid={productId}>{productName ?? 'Unnamed product'}</span>
            </div>
          )}
        </div>
      </SummarySectionV2.SummaryGridCalloutItem>
    );
  }

  return (
    <SummarySectionV2.SummaryGridCalloutItem testId="summary-total-billed-users">
      <div className="billed-users">
        <label>Last billed users</label>
        <div className="entitlement-details-column">{!totalBilledUsers ? 'N/A' : totalBilledUsers}</div>
      </div>
    </SummarySectionV2.SummaryGridCalloutItem>
  );
};
